import React from "react";
import { riskMeta, bandMeta, band } from "./shared";

// Small reusable risk pill used across the portfolio owner views.
// Prefers `score` (exact 80/60 band); falls back to a legacy `level` string.
export const RiskPill = ({ level, score, size = "sm" }) => {
  const hasScore = score !== null && score !== undefined && score !== "" && !Number.isNaN(Number(score));
  const m = hasScore ? bandMeta(score) : riskMeta(level);
  const key = hasScore ? band(score) : String(level || "no_data");
  const pad = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return (
    <span
      data-testid={`risk-pill-${key}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${pad}`}
      style={{ background: m.bg, color: m.fg }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.dot }} />
      {m.label}
    </span>
  );
};
